document.addEventListener("DOMContentLoaded", (async function() {
    console.log('=== Infinite Scroll Debug ===');

    // State variables
    let currentPage = 1;
    let isLoading = false;
    let hasMorePosts = true;
    let maxPages = null;
    let selectedYear = null;
    let selectedCategory = null;
    let searchQuery = null;
    let observedPosts = new Set();

    // Get attributes from PHP
    const attributesElement = document.getElementById("infinite-scroll-attributes");
    const fontFamily = attributesElement.getAttribute("data-font-family");
    const textColor = attributesElement.getAttribute("data-text-color");
    const backgroundColor = attributesElement.getAttribute("data-rgba-background-color");
    const postsPerPage = parseInt(attributesElement.getAttribute("data-posts-per-page")) || 5;
    const cutoffDate = attributesElement.getAttribute("data-cutoffdate");

    // DOM elements
    const loadingIndicator = document.getElementById("loading-indicator");
    const sentinel = document.getElementById("sentinel");
    const container = document.getElementById("infinite-scroll-container");
    const toggleFilters = document.getElementById("toggle-filters");
    const filterContainer = document.getElementById("filter-container");
    const clearFiltersBtn = document.getElementById("clear-filters");
    const searchInput = document.querySelector('.search_input_infinte');

    // Track already rendered posts from PHP
    function trackExistingPosts() {
        const existingPosts = container.querySelectorAll('[data-postid]');
        existingPosts.forEach(postElement => {
            const postId = postElement.getAttribute('data-postid');
            observedPosts.add(postId);
            console.log('Tracked existing post:', postId);
        });
        console.log('Total existing posts:', existingPosts.length);
    }

    // Show/hide loading indicator
    function showLoading(show) {
        if (loadingIndicator) {
            loadingIndicator.style.display = show ? "block" : "none";
        }
    }

    // Update sentinel element
    function updateSentinel() {
        if (sentinel) {
            sentinel.innerHTML = hasMorePosts ? "" : "<div class='no-more-posts'>No more posts.</div>";
        }
    }

    // Clear all filters and reset state
    function clearFilters() {
        selectedYear = null;
        selectedCategory = null;
        searchQuery = null;

        document.querySelectorAll("#year-filter li, #category-filter li").forEach((element) => {
            element.classList.remove("active");
        });

        if (searchInput) {
            searchInput.value = "";
        }

        currentPage = 1;
        hasMorePosts = true;
        observedPosts.clear();
        // Don't clear container - let PHP render initial posts again or reload
        location.reload(); // Simple solution: reload the page
    }

    // Build API URL that works with your WordPress setup
    function buildApiUrl(params) {
        const baseUrl = window.location.origin;
        const queryString = new URLSearchParams(params).toString();
        
        // Try different URL formats to find what works
        const urlOptions = [
            `${baseUrl}/wp-json/wp/v2/posts?${queryString}`,
            `${baseUrl}/index.php?rest_route=/wp/v2/posts&${queryString}`,
            `${baseUrl}?rest_route=/wp/v2/posts&${queryString}`
        ];
        
        console.log('Trying URLs:', urlOptions);
        return urlOptions[0]; // Try the standard REST API first
    }

    // Fetch posts from API
    async function fetchPosts(page, isInitialLoad = false) {
        if (isLoading || (maxPages !== null && page > maxPages)) return;

        isLoading = true;
        
        // Only show loading indicator for subsequent loads, not initial load
        if (!isInitialLoad) {
            showLoading(true);
        }
        
        console.log(`Fetching page ${page}...`);

        try {
            // Build query parameters
            const params = {
                page: page,
                per_page: postsPerPage,
                order: 'desc',
                orderby: 'date',
                _embed: 'true',
                before: `${new Date().getFullYear()}-01-01T00:00:00`
            };

            // Add filters
            if (selectedYear) {
                params.after = `${selectedYear}-01-01T00:00:00`;
                params.before = `${selectedYear}-12-31T23:59:59`;
            }
            if (selectedCategory) {
                params.categories = selectedCategory;
            }
            if (searchQuery) {
                params.search = searchQuery;
            }
            if (cutoffDate) {
                params.after = cutoffDate;
            }

            const apiUrl = buildApiUrl(params);
            console.log('API URL:', apiUrl);

            const response = await fetch(apiUrl);

            console.log('Response status:', response.status);
            
            if (!response.ok) {
                // If standard REST API fails, try alternative format
                console.log('Trying alternative URL...');
                const altUrl = `${window.location.origin}/index.php?rest_route=/wp/v2/posts&${new URLSearchParams(params).toString()}`;
                console.log('Alternative URL:', altUrl);
                
                const altResponse = await fetch(altUrl);
                if (altResponse.ok) {
                    const posts = await altResponse.json();
                    processPosts(posts, page, altResponse, isInitialLoad);
                    return;
                }
                
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const posts = await response.json();
            processPosts(posts, page, response, isInitialLoad);
            
        } catch (error) {
            console.error("Error fetching posts:", error);
            hasMorePosts = false;
            updateSentinel();
            
            if (page === 1 && isInitialLoad) {
                container.innerHTML = `
                    <div style="text-align: center; padding: 40px; color: ${textColor};">
                        <h3>Error Loading Posts</h3>
                        <p>${error.message}</p>
                        <p><small>Please check if the REST API is enabled.</small></p>
                        <button onclick="location.reload()" style="padding: 10px 20px; margin: 10px;">Retry</button>
                    </div>
                `;
            }
        } finally {
            isLoading = false;
            showLoading(false);
        }
    }

    // Process posts after successful fetch
    function processPosts(posts, page, response, isInitialLoad = false) {
        console.log(`Received ${posts.length} posts for page ${page}`);

        // Get total pages from headers
        const totalPages = response.headers.get("X-WP-TotalPages");
        if (totalPages) {
            maxPages = parseInt(totalPages, 10);
            console.log('Total pages available:', maxPages);
        }

        if (posts.length > 0) {
            // For initial load (page 1), only add posts if we're doing a filter/search
            // Otherwise, the PHP-rendered posts should stay
            if (page === 1 && (selectedYear || selectedCategory || searchQuery)) {
                // Clear container only when filtering
                container.innerHTML = '';
                observedPosts.clear();
            }
            
            displayPosts(posts);
            hasMorePosts = page < maxPages;
        } else {
            hasMorePosts = false;
            console.log('No posts returned for this page');
        }

        updateSentinel();
    }

    // Display posts in the container
    function displayPosts(posts) {
        posts.forEach(post => {
            if (observedPosts.has(post.id)) {
                console.log('Skipping duplicate post:', post.id);
                return;
            }

            const category = post._embedded?.["wp:term"]?.[0]?.[0]?.name || 'Uncategorized';
            const authorName = post._embedded?.author?.[0]?.name || 'Unknown';
            const isArchive = new Date(post.date).getFullYear() < new Date().getFullYear();
            const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;

            const postElement = document.createElement("a");
            postElement.className = "infinite_scroll_card short_tag";
            postElement.href = post.link;
            postElement.style.cssText = `
                background-color: ${backgroundColor};
                color: ${textColor};
                font-family: ${fontFamily};
                text-decoration: none;
                display: block;
                margin-bottom: 20px;
                padding: 15px;
                border-radius: 5px;
            `;

            const imageHtml = featuredImage 
                ? `<img class="infinite_scroll_card_image" src="${featuredImage}" alt="${post.title.rendered}" style="max-width: 100%; height: auto;" />`
                : '<div class="no-image">&nbsp;</div>';

            const archiveBadge = isArchive ? "<div class='achrive_post'><h4>ARCHIVE</h4></div>" : "";

            postElement.innerHTML = `
                ${imageHtml}
                ${archiveBadge}
                <h4 class="infinite_scroll_card_byline">${category}</h4>
                <h3 class="infinite_scroll_card_text">${post.title.rendered}</h3>
                <h4 class="infinite_scroll_card_author">by ${authorName} on ${formatDate(post.date)}</h4>
            `;

            postElement.setAttribute("data-postid", post.id);
            container.appendChild(postElement);
            observedPosts.add(post.id);
            console.log('Added post:', post.id);
        });
    }

    // Format date
    function formatDate(dateString) {
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
            });
        } catch (error) {
            return 'Invalid date';
        }
    }

    // Fetch years for filter
    async function fetchYears() {
        try {
            const params = {
                per_page: 1,
                order: 'asc',
                orderby: 'date'
            };
            
            const apiUrl = buildApiUrl(params);
            const response = await fetch(apiUrl);
            const posts = await response.json();
            const firstPostYear = posts.length ? new Date(posts[0].date).getFullYear() : 2020;
            const yearFilter = document.getElementById("year-filter");
            
            if (yearFilter) {
                yearFilter.innerHTML = "<li data-value='' class='filter_item' style='cursor: pointer; padding: 5px 10px;'>All Years</li>";
                
                let yearsArray;
                if (cutoffDate) {
                    const cutoffYear = new Date(cutoffDate).getFullYear();
                    yearsArray = Array.from(
                        { length: cutoffYear - firstPostYear + 1 },
                        (_, index) => firstPostYear + index
                    );
                } else {
                    const currentYear = new Date().getFullYear();
                    yearsArray = Array.from(
                        { length: currentYear - firstPostYear + 1 },
                        (_, index) => firstPostYear + index
                    );
                }
                
                yearsArray.reverse().forEach(year => {
                    const listItem = document.createElement("li");
                    listItem.classList.add("filter_item");
                    listItem.textContent = year;
                    listItem.dataset.value = year;
                    listItem.style.cursor = 'pointer';
                    listItem.style.padding = '5px 10px';
                    yearFilter.appendChild(listItem);
                });
            }
        } catch (error) {
            console.error("Error fetching years:", error);
        }
    }

    // Fetch categories for filter
    async function fetchCategories() {
        try {
            const apiUrl = buildApiUrl({});
            const categoriesUrl = apiUrl.replace('/wp/v2/posts', '/wp/v2/categories');
            const response = await fetch(categoriesUrl);
            const categories = await response.json();
            const categoryFilter = document.getElementById("category-filter");
            
            if (categoryFilter) {
                categoryFilter.innerHTML = "<li data-value='' class='filter_item' style='cursor: pointer; padding: 5px 10px;'>All Categories</li>";
                categories.forEach(category => {
                    const listItem = document.createElement("li");
                    listItem.classList.add("filter_item");
                    listItem.textContent = category.name;
                    listItem.dataset.value = category.id;
                    listItem.style.cursor = 'pointer';
                    listItem.style.padding = '5px 10px';
                    categoryFilter.appendChild(listItem);
                });
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    }

    // Toggle filters visibility
    if (toggleFilters && filterContainer) {
        let filtersVisible = false;
        toggleFilters.addEventListener("click", function() {
            filtersVisible = !filtersVisible;
            filterContainer.style.display = filtersVisible ? "grid" : "none";
            toggleFilters.textContent = filtersVisible ? "HIDE FILTERS" : "SHOW FILTERS";
        });
    }

    // Intersection Observer for infinite scroll
    const intersectionObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && hasMorePosts && !isLoading) {
                    console.log('Sentinel visible, loading next page...');
                    currentPage++;
                    fetchPosts(currentPage, false);
                }
            });
        },
        {
            rootMargin: "100px",
            threshold: 0.1
        }
    );

    // Initialize the application
    async function initialize() {
        console.log('Initializing infinite scroll...');

        // Track posts that were rendered by PHP
        trackExistingPosts();

        // Set current page to 2 since PHP already rendered page 1
        currentPage = 2;

        // Set up filter listeners
        function setupFilterListeners() {
            // Year filter
            document.querySelectorAll("#year-filter li").forEach(item => {
                item.addEventListener("click", () => {
                    selectedYear = item.dataset.value || null;
                    selectedCategory = null;
                    searchQuery = null;
                    currentPage = 1;
                    hasMorePosts = true;
                    observedPosts.clear();
                    container.innerHTML = "";
                    updateSentinel();
                    fetchPosts(currentPage, true);
                });
            });

            // Category filter
            document.querySelectorAll("#category-filter li").forEach(item => {
                item.addEventListener("click", () => {
                    selectedCategory = item.dataset.value || null;
                    selectedYear = null;
                    searchQuery = null;
                    currentPage = 1;
                    hasMorePosts = true;
                    observedPosts.clear();
                    container.innerHTML = "";
                    updateSentinel();
                    fetchPosts(currentPage, true);
                });
            });

            // Search input
            if (searchInput) {
                let searchTimeout;
                searchInput.addEventListener("input", (e) => {
                    clearTimeout(searchTimeout);
                    searchTimeout = setTimeout(() => {
                        searchQuery = e.target.value.trim() || null;
                        selectedYear = null;
                        selectedCategory = null;
                        currentPage = 1;
                        hasMorePosts = true;
                        observedPosts.clear();
                        container.innerHTML = "";
                        updateSentinel();
                        fetchPosts(currentPage, true);
                    }, 500);
                });
            }

            // Clear filters button
            if (clearFiltersBtn) {
                clearFiltersBtn.addEventListener("click", clearFilters);
            }
        }

        // Populate filters
        async function populateFilters() {
            await fetchYears();
            await fetchCategories();
            setupFilterListeners();
        }

        await populateFilters();

        // Initialize sentinel element
        let sentinelElement = document.getElementById("sentinel");
        if (!sentinelElement) {
            sentinelElement = document.createElement("div");
            sentinelElement.id = "sentinel";
            sentinelElement.style.height = "1px";
            container.appendChild(sentinelElement);
        }
        intersectionObserver.observe(sentinelElement);

        console.log('Infinite scroll initialized successfully');
    }

    // Start the application
    initialize();
}));